import { FC, useContext, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import NotificationDispatch, {
  showErrorNotification,
  showSuccessNotification,
} from "../../context/notificationContext";
import { useI18n } from "../../hooks/useTranslations";
import { useAdminFinesApi } from "../../http/fines/api";
import { UpsertFine } from "../../http/fines/types";
import Header from "../ui/Header";
import Panel from "../ui/Panel";
import FineForm, { FineFormBody } from "./FineForm";

const NewFine: FC = () => {
  const i18n = useI18n();
  const dispatch = useContext(NotificationDispatch);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const finesApi = useAdminFinesApi();
  const navigate = useNavigate();

  const [params] = useSearchParams();
  const carId = params.get("car_id");

  const onSubmit = async (formData: FineFormBody) => {
    const body: UpsertFine = {
      carId: carId || formData.car?.id || "",
      driverId: formData.driver?.id ?? "",
      subsidiaryId: formData.subsidiary?.id ?? "",
      status: formData.status.value,
      verbalNumber: formData.verbalNumber,
      violationDate: formData.violationDate,
      communicationDate: formData.communicationDate,
      amount: formData.amount ?? undefined,
      amountCurrency: formData.amountCurrency?.value,
      points: formData.points ?? undefined,
      accountantId: formData.accountant?.id ?? null,
      hrReferentId: formData.hrReferent?.id ?? null,
      note: formData.note,
      currentVersionNumber: 1,
    };

    setIsSubmitting(true);
    try {
      const response = await finesApi.insertAdminFine(body);
      dispatch(showSuccessNotification(i18n.t));

      const redirectUrl = params.get("redirect_uri");
      navigate(redirectUrl || `/admin/fines/${response.id}`);
    } catch (error) {
      dispatch(showErrorNotification(i18n, error));
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <Header title={i18n.t.fines.new} />
      <Panel>
        <FineForm isDisabled={isSubmitting} onSubmit={onSubmit} carId={carId} />
      </Panel>
    </>
  );
};

export default NewFine;
